import React from 'react';
import {Text, View} from '@react-pdf/renderer';
import {
    getBulletPointStyles,
    getInstructionsTitleStyles,
    getLuggageTagInstructions
} from "../../utils/themePdfUtils";

function LuggageTagInstructions(props) {
    return (
        <View style={{paddingHorizontal: "14px", textAlign: "left"}}>
            <Text style={{textTransform: "uppercase", fontWeight: "bold", ...getInstructionsTitleStyles()}}>
                {getLuggageTagInstructions()}
            </Text>
            <View style={{marginTop: "6px", fontSize: "9px"}}>
                {props.instructions.map((instruction, index) =>
                    <ListItem key={index} content={instruction}/>
                )}
            </View>
        </View>
    );
}

export default LuggageTagInstructions;

function ListItem(props) {
    const textStyle = props.content.style || {};

    return(
        <View style={{display: "flex", flexDirection: "row", alignItems: "flex-start", marginBottom: "6px"}}>
            <View style={{marginTop: "3px", marginRight: "4px", flexShrink: 0, ...getBulletPointStyles(textStyle.fontSize)}}/>
            <View style={{flexShrink: 1, paddingRight: "8px"}}>
                <Text style={textStyle}>
                    {props.content.text}
                </Text>
            </View>
        </View>
        )
}